import { render, staticRenderFns } from "./MuolajaPechat.vue?vue&type=template&id=7bd43dae"
import script from "./MuolajaPechat.vue?vue&type=script&lang=js"
export * from "./MuolajaPechat.vue?vue&type=script&lang=js"
import style0 from "./MuolajaPechat.vue?vue&type=style&index=0&id=7bd43dae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports